import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { of } from 'rxjs/observable/of';

/**
 * Data resolver for different routes
 */
@Injectable()
export class DataResolver implements Resolve<any> {
    /**
     * resolve method
     * @param {ActivatedRouteSnapshot} route - ActivatedRouteSnapshot
     * @param {RouterStateSnapshot} state - RouterStateSnapshot
     * @returns {Observable<{res: string}>}
     */
    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return of({res: 'I am data'});
    }
}

/**
 * An array of services to resolve routes with data.
 * @type {DataResolver[]} - data resolver
 */
export const APP_RESOLVER_PROVIDERS = [
    DataResolver
];



// WEBPACK FOOTER //
// ./src/app/app.resolver.ts